/* eslint-disable react/jsx-no-useless-fragment */
import { Flex, Box, VizFooter } from '@ouster/webviz-react-components';

import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import SideNav from '../components/SideNav';
import { Toast } from '../components/Toast';
import NavUser from '../components/users/NavUser';
import {
  FlexColumnWithNav,
  NavFullHeightContainer,
  NavFlexRow,
} from '../containers/NavBar';
import { useStoreState, useStoreActions } from '../reducers';

const DefaultLayout = () => {
  const { appUser, user } = useStoreState((storeState) => storeState.user);
  const { fetchUserOrgs } = useStoreActions((actions) => actions.user);

  useEffect(() => {
    if (user?.identity_id) {
      fetchUserOrgs(user?.identity_id);
    }
  }, [fetchUserOrgs, user?.identity_id]);

  return (
    <>
      {appUser ? (
        <>
          <FlexColumnWithNav
            navRightEl={
              <NavFullHeightContainer>
                <NavFlexRow gap="16px">
                  <NavUser />
                </NavFlexRow>
              </NavFullHeightContainer>
            }
          >
            <Box h="100%" display="grid" gridTemplateRows="1fr auto">
              <Flex overflow="auto">
                <Box
                  w="min-content"
                  bg="var(--ouster-colors-background-surface-subtle)"
                  borderRight="1px solid"
                  borderColor="var(--color-unify-white-30)"
                  py={4}
                  position="relative"
                >
                  <SideNav />
                </Box>
                <Box
                  flex={1}
                  height="100%"
                  overflowX="hidden"
                  bg="var(--color-gray-11)"
                >
                  <Outlet />
                </Box>
              </Flex>
              <VizFooter
                mode="none"
                borderTop="1px solid"
                borderColor="var(--color-unify-white-10)"
                py="1em"
              />
            </Box>
          </FlexColumnWithNav>
          <Toast />
        </>
      ) : (
        <Box w="100%" h="100%" display="grid" placeContent="center">
          <CircularProgress size="50px" thickness={2} />
        </Box>
      )}
    </>
  );
};

export default DefaultLayout;
